import { addDays, format, parse } from 'date-fns';

export function formatTimeToShortAMPM(timeString: string | undefined): string {
  if (!timeString) {
    return '';
  }

  const parsedTime = parse(timeString, 'hh:mm a', new Date());

  if (isNaN(parsedTime.getTime())) {
    const parsedTimeWithoutAMPM = parse(timeString, 'HH:mm', new Date());
    if (isNaN(parsedTimeWithoutAMPM.getTime())) {
      return '';
    }
    return format(parsedTimeWithoutAMPM, 'hh:mmaaa');
  }

  return format(parsedTime, 'hh:mmaaa');
}

export function concatenateDateTime(dateStr: string, timeStr: string): string {
  const dateTimeStr = `${dateStr} ${timeStr}`;
  const combinedDateTime = parse(dateTimeStr, 'yyyy-MM-dd hh:mm a', new Date());
  const formattedDateTime = format(combinedDateTime, "yyyy-MM-dd'T'HH:mm:ssXXX");

  return formattedDateTime;
}

export function addDaysToDate(date: string, daysToAdd: number): string {
  if (!date) {
    return '';
  }

  const initialDate = new Date(date);
  const newDate = addDays(initialDate, daysToAdd);

  return format(newDate, "yyyy-MM-dd'T'HH:mm:ssXXX");
}
